import { createGlobalStyle } from "styled-components";

type Props = {
  fontName: string;
};

export const GlobalStyle = createGlobalStyle<Props>`
:root {
  --white: #ffffff;
  --black: #000000;
  --bg-color: #ffffff;
  --bg-color-rgb: 255, 255, 255;
  --bg-button: #b55755;
  --bg-button-rgb: 181, 87, 85;
  --title-text-color: #2D3748;
  --title-text-color-rgb: 45, 55, 72;
  --text-color: #626976;
  --text-color-rgb: 98, 105, 118;
  --button-text-color: #ffffff;
  --button-text-color-rgb: 255, 255, 255;
  --article-bg: 85, 106, 181, 0.15;
  --bg-back-button: 255, 255, 255, 0.35;
}

body {
  height: 100%;
  margin: 0 auto;
  font-family:'${({ fontName }) => fontName}', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //background-color: #000;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}
ul,
ol {
  margin: 0;
  padding: 0;
}
img {
  display: block;
  max-width: 100%;
  height: auto;
}

main,
span,
ol,
ul,
pre,
div {
    // Firefox
    scrollbar-width: thin;

    // Webkit
    &::-webkit-scrollbar {
        width: 0.4rem;
        height: 0.4rem;
    }
}



`;
